import Tags from '@framework/ui/Organisms/Filters/FiltersPanel/Tags';
import { IMarketArticlesFilterPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import { filtersKeys } from '@/creditflowresearch/ui/components/creditFlow/articles/FiltersButton/Sections/constants';
import { createFiltersFormatter } from '@framework/ui/Organisms/Filters/FiltersPanel/Tags/helpers';
import {
  useArticlesFilterContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/Filter/ArticlesFilterContext';

const filtersFormatter = createFiltersFormatter();

type FilterValueType = number | null | boolean | string[];

interface ISidebarTagsProps {
  filters: IMarketArticlesFilterPayload,
  onTagRemove: (filterName: string, filterValue: FilterValueType) => void,
}

const SidebarTags = ({ filters, onTagRemove }: ISidebarTagsProps) => {
  const { state: { dateToMax, dateFromMin } } = useArticlesFilterContext();
  const includedSectorIds = [...(filters.includedSectorIds || []), ...(filters.includedSubsectorIds || [])];

  let tagsFilters = getFiltersByKeysWithValues({ filtersState: filters, filtersKeys, dateFromMin, dateToMax });

  if (includedSectorIds.length) {
    tagsFilters = { ...tagsFilters, includedSectorIds };
  }

  return (
    <Tags
      onTagRemove={ onTagRemove }
      filters={ tagsFilters }
      filtersFormatter={ filtersFormatter }
      allowedToRemoveFilters={ filtersKeys }
    />
  );
};

export default SidebarTags;
